(function () {
  var ORDINALS = ['1er', '2e', '3e', '4e', '5e', '6e'];

  function tierForSize(size) {
    if (size === 1) return 'solo';
    if (size === 6) return 'hexa';
    return 'duo';
  }

  function formatMoney(amount) {
    return amount.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function init(root) {
    var script = root.querySelector('[data-pack-flavors]');
    if (!script) return;

    var flavors;
    try {
      flavors = JSON.parse(script.textContent);
    } catch (err) {
      return;
    }
    if (!flavors || !flavors.length) return;

    var params = new URLSearchParams(window.location.search);
    var requestedSize = parseInt(params.get('size'), 10);
    var size = [1, 2, 6].indexOf(requestedSize) !== -1 ? requestedSize : 2;
    var tier = tierForSize(size);

    var headingEl = root.querySelector('[data-pack-heading]');
    if (headingEl) {
      headingEl.textContent =
        size === 1
          ? 'Choisissez votre goût'
          : 'Composez votre pack de ' + size + ' boîtes';
    }

    var stepsEl = root.querySelector('[data-pack-steps]');
    var summaryListEl = root.querySelector('[data-pack-summary-list]');
    var totalEl = root.querySelector('[data-pack-total]');
    var submitBtn = root.querySelector('[data-pack-submit]');
    var errorEl = root.querySelector('[data-pack-error]');

    var selections = new Array(size).fill(null);

    function renderStep(index) {
      var wrap = document.createElement('div');
      wrap.className = 'pack-composer__step';

      var title = document.createElement('h2');
      title.className = 'pack-composer__step-title';
      title.textContent =
        size === 1
          ? 'Votre goût'
          : 'Étape ' + (index + 1) + ' — Choisissez votre ' + (ORDINALS[index] || index + 1 + 'e') + ' goût';
      wrap.appendChild(title);

      var grid = document.createElement('div');
      grid.className = 'pack-composer__grid';

      flavors.forEach(function (flavor, flavorIndex) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pack-composer__flavor';
        btn.dataset.step = index;
        btn.dataset.flavor = flavorIndex;
        btn.innerHTML =
          '<span class="pack-composer__flavor-emoji">' +
          (flavor.emoji || '') +
          '</span><span class="pack-composer__flavor-label">' +
          flavor.label +
          '</span>';
        btn.addEventListener('click', function () {
          selections[index] = flavorIndex;
          grid.querySelectorAll('.pack-composer__flavor').forEach(function (el) {
            el.classList.remove('is-selected');
          });
          btn.classList.add('is-selected');
          updateSummary();
        });
        grid.appendChild(btn);
      });

      wrap.appendChild(grid);
      return wrap;
    }

    for (var i = 0; i < size; i++) {
      stepsEl.appendChild(renderStep(i));
    }

    function updateSummary() {
      var counts = {};
      var order = [];
      selections.forEach(function (flavorIndex) {
        if (flavorIndex === null || flavorIndex === undefined) return;
        var label = flavors[flavorIndex].label;
        if (!(label in counts)) {
          counts[label] = 0;
          order.push(label);
        }
        counts[label] += 1;
      });

      summaryListEl.innerHTML = '';
      order.forEach(function (label) {
        var li = document.createElement('li');
        li.textContent = counts[label] + ' × ' + label;
        summaryListEl.appendChild(li);
      });

      var allChosen = selections.every(function (s) {
        return s !== null && s !== undefined;
      });

      var total = 0;
      if (allChosen) {
        selections.forEach(function (flavorIndex) {
          total += parseFloat(flavors[flavorIndex][tier].price);
        });
      }
      totalEl.textContent = formatMoney(total);
      submitBtn.disabled = !allChosen;
    }

    updateSummary();

    submitBtn.addEventListener('click', function () {
      var allChosen = selections.every(function (s) {
        return s !== null && s !== undefined;
      });
      if (!allChosen) return;

      submitBtn.disabled = true;
      errorEl.hidden = true;

      var packId = 'pack-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
      var items = selections.map(function (flavorIndex, stepIndex) {
        var flavor = flavors[flavorIndex];
        return {
          id: flavor[tier].id,
          quantity: 1,
          properties: {
            _pack_id: packId,
            _pack_size: String(size),
            _pack_box: String(stepIndex + 1),
            _pack_flavor: flavor.label
          }
        };
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (data) {
              throw new Error((data && data.description) || 'Erreur lors de l’ajout au panier.');
            });
          }
          return response.json();
        })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function (err) {
          errorEl.textContent = err.message || 'Une erreur est survenue. Merci de réessayer.';
          errorEl.hidden = false;
          submitBtn.disabled = false;
        });
    });
  }

  document.querySelectorAll('[data-pack-composer]').forEach(init);
})();
